// actions.js
export const RESET_STATE = "RESET_STATE";
